import { fetcher } from '@commenda/utils';
import { ProductsBulkDeleteProps } from './types';

type DeleteProductResult = {
  success: boolean;
  error?: string;
};

type BulkDeleteProductResult = {
  success: boolean;
  message?: string;
  error?: string;
};

export async function deleteSalesTaxProduct(
  token: string,
  productId: string,
  corporationId: number
): Promise<DeleteProductResult> {
  try {
    const response = await fetcher(
      `new-sales-tax/products/${productId}/corporation/${corporationId}`,
      { method: 'DELETE' },
      token
    );

    if (!response.ok) {
      const errorData = await response.json();
      console.error('Error deleting product:', errorData);
      return {
        success: false,
        error: errorData.message || 'Failed to delete product',
      };
    }

    return {
      success: true,
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to delete product';
    console.error('Failed to delete product:', error);
    return {
      success: false,
      error: errorMessage,
    };
  }
}

export async function bulkDeleteSalesTaxProducts(
  body: ProductsBulkDeleteProps,
  token: string
): Promise<BulkDeleteProductResult> {
  try {
    const response = await fetcher(
      'new-sales-tax/products/bulk/delete',
      { method: 'POST', body },
      token
    );

    if (!response.ok) {
      const errorData = await response.json();
      return {
        success: false,
        error: errorData.message || 'Failed to bulk delete products',
      };
    }

    const data = await response.json();
    return {
      success: true,
      message: data.message || 'Products deleted successfully',
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to bulk delete products';
    return {
      success: false,
      error: errorMessage,
    };
  }
}
